// extracted by mini-css-extract-plugin
export default {"wrapper":"SortIcon_wrapper__B-cp7","method_asc":"SortIcon_method_asc__2TOJT","method_desc":"SortIcon_method_desc__P4Nup"};